<template>
  <el-main>
    <query-gather :is-add="authorityMap.isAdd" :is-input="true" :is-query="true" :is-reset="true"
                  :cur-input-tip="curInputTip"
                  style="margin-top: -2vh"
                  @qgAddDeal="addItemDeal" @qgQueryDeal="qgQuery"
                  @qgResetDeal="resetRyDataDeal"></query-gather>
    <div class="commonDiv">
      <el-table
          :data="ryTableData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          border
          ref="ryTableRef"
          size="mini"
          @selection-change="tableSelectionChange"
          @sort-change="rySortChange"
          :row-style="tableRowClassName"
          max-height="calc(100% - 60px)"
          style="width: 100%;"
          height="calc(100% - 60px)"
          :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.6rem',textAlign:'center',color:'#323232',
                          fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}">
        <template v-for="(item,index) in ryTitles">
          <template v-if="index ===0">
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip>
              <template slot-scope="scope">
                <a style="color: #46adf5; cursor: pointer;"
                   @click="ryClickDeal(scope.row)">{{ scope.row.xm }}</a>
              </template>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column
                :prop="item.prop"
                :width="item.width"
                :label="item.label"
                :align="item.align"
                :sortable="item.sortable"
                show-overflow-tooltip
            ></el-table-column>
          </template>

        </template>
        <el-table-column label="操作" align="center" width="150" v-if="authorityMap.isDel">
          <template slot-scope="scope">
            <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
              <el-popconfirm
                  title="确定删除吗？"
                  @confirm="ryItemDeleteDeal(scope.row)"
              >
                <img
                    src="~@/assets/images/operates/delete.png"
                    alt=""
                    slot="reference"
                    style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                />
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>

      </el-table>
      <div class="commonPage2">
        <el-pagination
            @size-change="ryHandleSizeChange"
            @current-change="gzHandleCurrentChange"
            :page-sizes="[10, 20, 30]"
            :page-size="params.size"
            :current-page="params.current"
            layout="total, prev, pager, next,sizes, jumper"
            background
            :total="params.total"
        >
        </el-pagination>
      </div>
    </div>
    <data-dialog :dialog-title="ryDialog.title" :is-visible="ryDialog.ryFormVisible" :is-read="isRead"
                 @dgVerifyDeal="dgVerifyDeal('ryDialog','dialog')" ref="ryDialog" @dgConfirmDeal="dgRyConfirmDeal"
                 @dgCancelDeal="dgCancelDeal">
      <div slot="dialogFrom">
        <el-form ref="dialog" :model="ryDialog.data" :rules="ryRules" label-width="100px" label-position="top"
                 :disabled="isRead"
                 class="commonForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="姓名" prop="xm" style="width: 70%;">
                <el-input v-model="ryDialog.data['xm']" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机" prop="sj" style="width: 70%;">
                <el-input v-model="ryDialog.data['sj']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="职务" prop="zw" style="width: 70%;">
                <el-input v-model="ryDialog.data['zw']" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="序号" prop="no" style="width: 70%;">
                <el-input v-model="ryDialog.data['no']" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否自动接收" prop="recvsms" style="width: 70%;">
                <el-radio-group v-model="ryDialog.data['recvsms']">
                  <el-radio :label="true" :value="true">是</el-radio>
                  <el-radio :label="false" :value="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </data-dialog>
  </el-main>
</template>

<script>
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";
import BottomPagination from "../../components/tableGather/bottomPagination";

/**
 * @Author: ygh
 * @Date: 2024/3/11 10:39
 * @Description:人员信息页面
 */
export default {
  name: "staffInfo",
  mounted() {
    this.initStaffData();
  },
  components: {BottomPagination, DataDialog, QueryGather},
  data() {
    let validateXhNum = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^[0-9][0-9]*$/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 9) {
            return callback(new Error("序号长度不超过9个字符"));
          }
          callback();
        } else {
          return callback(new Error("序号只能填0-9的数字"));
        }
      }
    };
    let mobilephoneRules = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        const reg = /^1[3-9]\\d{9}$|/;
        if (reg.test(value)) {
          value = value + '';
          if (value.length > 11) {
            return callback(new Error("手机号码最多11位"));
          }
          callback();
        } else {
          return callback(new Error("手机号码格式错误"));
        }
      }
    };
    let validateMcLen = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length > 30) {
          return callback(new Error("长度不能超过30个字符"));
        } else {
          return callback();
        }
      }
    };

    return {
      authorityMap: {
        isAdd: false,//新增权限
        isUpdate: false,//修改权限
        isDel: false,//删除权限
        isView: false,//查看权限
      },
      isRead: false,
      stRemHeight: 0,
      isAddData:false,
      curInputTip: '请输入姓名或者手机',
      staffDataArr: [],
      ryTitles: [
        {
          prop: 'xm', label: '姓名', width: null, align: 'center', sortable: 'custom',
        },
        {
          prop: 'sj', label: '手机', width: null, align: 'center', sortable: false,
        },
        {
          prop: 'zw', label: '职务', width: null, align: 'left', sortable: false,
        },
        {
          prop: 'recvsmsText', label: '是否自动接收', width: null, align: 'center', sortable: false,
        },
        {
          prop: 'no', label: '序号', width: null, align: 'center', sortable: 'custom',
        },
      ],
      ryTableData: [],
      ryRules: {
        xm: [
          {required: true, message: "请输入姓名", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        sj: [
          {required: true, message: "请输入手机号", trigger: "blur"},
          {validator: mobilephoneRules, trigger: 'blur'},
        ],
        zw: [
          {required: false, message: "请输入职务", trigger: "blur"},
          {validator: validateMcLen, trigger: 'blur'},
        ],
        recvsms: [
          {required: true, message: "请选择是否自动接收", trigger: "blur"},
        ],
        no: [
          {required: true, message: "请输入序号", trigger: "blur"},
          {validator: validateXhNum, trigger: 'blur'},
        ],
      },
      params: {
        total: 1,
        size: 10,
        current: 1,
      },
      loading: false,
      ryMultiple: true,
      ryMultipleSelection: [],
      curInputValue: '',
      ryDialog: {
        title: "",
        ryFormVisible: false,
        data: {
          'xm': '', //姓名
          'sj': '',//手机
          'zw': '', // 职务
          'no': '', // 序号
          'recvsms': true, //是否自动接收
        },
      },
      dialogData: {
        'xm': '', //姓名
        'sj': '',//手机
        'zw': '', // 职务
        'no': '', // 序号
        'recvsms': true, //是否自动接收
      },
    }
  },
  created() {
    let windowHeight =
        document.documentElement.clientHeight || document.bodyclientHeight;
    this.stRemHeight = windowHeight / 100;
  },
  methods: {
    initStaffData() {
      this.pageAuthorityDeal();
      this.getStaffData();
    },
    pageAuthorityDeal() {
      const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
      const qx = thirdAuthority[this.$route.name];
      if (qx === 'all' || qx === null) {
        this.authorityMap.isAdd = true;
        this.authorityMap.isDel = true;
        this.authorityMap.isUpdate = true;
        this.authorityMap.isView = true;
      } else {
        this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
        this.authorityMap.isDel = qx.indexOf('删除') !== -1;
        this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
        this.authorityMap.isView = qx.indexOf('查询') !== -1;
      }
      // console.log("当前页面三级菜单权限", thirdAuthority, this.authorityMap);
    },
    dgCancelDeal() {
      if (this.ryDialog.ryFormVisible) {
        this.ryDialog.ryFormVisible = false;
        this.$refs['dialog'].clearValidate();
      }
    },
    dgRyConfirmDeal() {
      this.isRead = false;
      if (this.isAddData) {
        this.addRy();
      } else {
        this.updateRy();
      }
    },
    dgVerifyDeal(dgRef, frRef) {
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    addRy() {
      this.request.post('/rm-bresuser/v1', this.ryDialog.data).then(res => {
        if (res.ok) {
          this.ryDialog.ryFormVisible = false;
          this.ryDialog.data = {};
          this.isAddData = false;
          this.params = {
            total: 0,
            size: 10,
            current: 1,
          };
          this.$message.success('添加人员数据成功');
          this.getStaffData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    updateRy() {
      // console.log("======updateRy======", this.ryDialog.data);
      this.request.put('/rm-bresuser/v1', this.ryDialog.data).then(res => {
        if (res.ok) {
          this.ryDialog.ryFormVisible = false;
          this.ryDialog.data = {};
          this.isAddData = false;
          this.params = {
            total: 0,
            size: 10,
            current: 1,
          };
          this.$message.success('修改人员数据成功');
          this.getStaffData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    resetRyDataDeal() {
      this.curInputValue = '';
      this.clearTableStatus();
      this.getStaffData();
    },
    clearTableStatus() {
      this.$refs.ryTableRef.clearSort();
    },
    initGetRyData() {
      this.params = {
        total: 0,
        size: 10,
        current: 1,
      };
      this.getStaffData();
    },
    qgQuery(params) {
      this.curInputValue = params.curInputValue;
      this.params.current = 1;
      this.clearTableStatus();
      this.getStaffData();
    },
    addItemDeal() {
      this.ryDialog.title = '新增人员信息';
      this.ryDialog.ryFormVisible = true;
      this.ryDialog.data = {...this.dialogData};
      this.isAddData = true;
      this.isRead = false;
      // console.log("======addItemDeal======", this.ryDialog, this.btnIndex);
    },
    ryItemDeleteDeal(row) {
      this.request.delete('/rm-bresuser/v1/' + row['id']).then(res => {
        if (res.ok) {
          this.$message.success("数据删除成功");
          this.initGetRyData();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    rySortChange(column) {
      let params = {
        total: 0,
        size: 10,
        current: 1,
        sortCol: column.prop.toUpperCase(),
        order: column.order === "descending" ? 1 : 0,
      };
      this.params = {};
      this.params = params;
      this.getStaffData();
    },
    tableSelectionChange(val) {
      this.ryMultiple = !val.length;
      this.ryMultipleSelection = val;
    },
    ryClickDeal(row) {
      if (this.authorityMap.isView || this.authorityMap.isUpdate) {
        this.isAddData=false;
        this.setRyDataToDialog(row);
      }
    },
    setRyDataToDialog(row) {
      this.ryDialog.title = '人员信息'
      this.ryDialog.ryFormVisible = true;
      this.isRead = this.authorityMap.isView && !this.authorityMap.isUpdate;
      this.ryDialog.data = {};
      this.ryDialog.data = {...row};
      // console.log("======ry======", this.ryDialog.data);
    },
    tableRowClassName({row, rowIndex}) {
      return {
        backgroundColor: '#ffffff',
        fontSize: '1.4rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontFamily: 'PingFang SC',
        color: '#616f7b',
        height: '5.83vh',
      };
    },
    ryHandleSizeChange(val) {
      this.params.size = val;
      this.params.current = 1;
      this.getStaffData();
    },
    //切换页码
    gzHandleCurrentChange(val) {
      this.params.current = val;
      this.getStaffData();
    },
    getStaffData() {
      this.loading = true;
      let params = {
        ...this.params,
        'xmOrzh': this.curInputValue + '',
      }
      this.request.get('/rm-bresuser/v1/page', {params: params}).then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.ryTableData = [];

            for (let i = 0; i < res.data['records'].length; i++) {
              res.data['records'][i]['recvsmsText'] = res.data['records'][i]['recvsms'] === false ? '否' : '是';
            }
            this.ryTableData = res.data['records'];
            this.params.total = res.data['total'];
            this.params.size = res.data['size'];
            // console.log(res, '===getStaffDataRes===', this.ryTableData);
          } else {
            this.$message.info("获取人员信息数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetRyDataDeal();
    }
  }

}
</script>

<style scoped>
.commonForm {
  padding-top: 4vh;
  padding-left: 6vh;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 200px);
}

/deep/ .el-pagination{
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}
.commonPage2 {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}


</style>
